import { render, staticRenderFns } from "./MobContactUs.vue?vue&type=template&id=4b2c2f42&scoped=true&"
import script from "./MobContactUs.vue?vue&type=script&lang=js&"
export * from "./MobContactUs.vue?vue&type=script&lang=js&"
import style0 from "./MobContactUs.vue?vue&type=style&index=0&id=4b2c2f42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c2f42",
  null
  
)

export default component.exports